/**
 * 게시판 목록 공통 Mixin
 * - 검색, 페이징, 로딩 상태 관리 로직 공통화
 * - notice, news 등 게시판 페이지에서 사용
 */

export default {
  data() {
    return {
      boards: [],
      loading: false,
      error: null,

      // 페이징 상태
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,

      // 검색 상태
      searchKeyword: '',

      // UI 상태
      hasMore: false
    };
  },
  async created() {
    await this.loadBoards();
  },
  methods: {
    /**
     * 게시판 목록 조회 (서버 페이지네이션)
     * - 자식 컴포넌트에서 fetchAPI 메서드를 반드시 구현해야 함
     * @param {boolean} isLoadMore - 더보기 여부 (true: 누적, false: 초기화)
     */
    async loadBoards(isLoadMore = false) {
      if (this.loading) return;

      // fetchAPI 메서드가 정의되어 있는지 확인
      if (typeof this.fetchAPI !== 'function') {
        console.error('fetchAPI method must be implemented in the component');
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const params = {
          page: this.currentPage,
          size: this.pageSize
        };

        // 검색어가 있으면 추가
        if (this.searchKeyword) {
          params.searchtext = this.searchKeyword;
        }

        const response = await this.fetchAPI(params);
        let newBoards = response.data;
        if (typeof this.mapBoardRow === 'function') {
          newBoards = newBoards.map((row) => this.mapBoardRow(row));
        }

        // 더보기인 경우 기존 데이터에 추가, 아니면 교체
        if (isLoadMore) {
          this.boards = [...this.boards, ...newBoards];
        } else {
          this.boards = newBoards;
        }

        // 전체 개수는 응답 헤더에서 가져옴
        this.totalCount = parseInt(response.headers['x-total-count'] || 0);

        // 더 불러올 데이터가 있는지 확인
        this.hasMore = this.boards.length < this.totalCount;

      } catch (error) {
        this.error = '데이터를 불러오는 중 오류가 발생했습니다.';
        console.error('===== API 호출 에러 =====');
        console.error('에러:', error);
        console.error('에러 상세:', error.response?.data || error.message);
        console.error('========================');
      } finally {
        this.loading = false;
      }
    },

    /**
     * 더보기 버튼 클릭 핸들러
     */
    async loadMoreBoards() {
      if (!this.hasMore || this.loading) return;

      this.currentPage += 1;
      await this.loadBoards(true);
    },

    /**
     * 검색 핸들러
     * @param {string} keyword - 검색어
     */
    async handleSearch(keyword) {
      // 검색어 저장
      this.searchKeyword = keyword;

      // 페이지 초기화
      this.currentPage = 1;
      this.boards = [];

      // 검색 조건으로 재조회
      await this.loadBoards(false);
    },

    /**
     * 게시판 카드 클릭 핸들러
     * - 자식 컴포넌트에서 boardPath를 반드시 정의해야 함
     */
    handleBoardClick(id) {
      if (!this.boardPath) {
        console.error('boardPath must be defined in the component');
        return;
      }
      this.$router.push(`${this.boardPath}/${id}`);
    }
  }
};
